import type { FC } from "react";
import { useRef } from "react";

import { changeLanguage } from "~/i18n";
import { ArrowDown, Globe } from "~/icons";

import type { Option } from "../HeaderV2";
import useOutsideClick from "../useOutsideClick";

export type Props = {
  languageList: Array<Option>;
  locale: string;
};

export const LocaleSelect: FC<Props> = ({ languageList, locale }) => {
  const optionsList = useRef<HTMLDivElement | null>(null);
  const { ref, isActive, setIsActive } = useOutsideClick(false);
  const selectedLang = languageList?.find((item) => {
    if (item.lang === locale) {
      return item;
    }

    return undefined;
  });

  const handleButtonClick = (): void => {
    setIsActive(!isActive);
  };

  const handlePosition = (): void => {
    if (optionsList.current) {
      const rect = optionsList.current.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom > viewportHeight) {
        optionsList.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }
  };

  return (
    <div className="locale-switch">
      <div
        className="locale-switch-content"
        ref={ref}
        onMouseEnter={handlePosition}
      >
        <div
          className={`locale-switch-selected ${isActive && "active"}`}
          onClick={handleButtonClick}
        >
          <Globe className="locale-switch-icon-globe" />
          <span className="locale-switch-selected-title">
            {selectedLang ? selectedLang.key : "Pick"}
          </span>
          <ArrowDown className="locale-switch-icon-arrow" />
        </div>
        <div className="locale-switch-options-wrapper" ref={optionsList}>
          <div
            className={`locale-switch-options-list ${
              isActive ? "active-list" : "closed-list"
            }`}
          >
            {languageList?.map((item) => (
              <div
                key={item.id}
                className="locale-switch-option"
                onClick={() => changeLanguage(item.lang)}
              >
                {item?.icon && <img src={item.icon} alt={item.key} />}
                <span className="locale-switch-option-title">{item.key}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
